import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/page/layout'
import Home from '@/page/home'
import Order from '@/page/order'
import mineManage from "@/page/mineManage"
import userManage from "@/page/userManage"
import applyManage from "@/page/applyManage"
import treeManage from "@/page/treeManage"
import tipsTplManage from "@/page/tipsTplManage"
import timeTplManage from "@/page/timeTplManage"
import projectManage from "@/page/projectManage"
import login from "@/page/login"
import backendUserManage from "@/page/backendUserManage"
import spotManage from "@/page/spotManage"
import spotMonitorManage from "@/page/spotMonitorManage"
import spotMonitorDetail from "@/page/spotMonitorDetail"
import spotDetail from "@/page/spotDetail"
import spotCompare from "@/page/spotCompare"
import districtMapConfig from "@/page/districtMapConfig"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/',
      component: Layout,
      children: [{
        path: '/',
        name: 'Home',
        component: Home
      }, {
        path: 'order',
        name: 'Order',
        component: Order
      }, {
        path: 'mineManage',
        name: 'mineManage',
        component: mineManage
      }, {
        path: 'userManage',
        name: 'userManage',
        component: userManage
      }, {
        path: 'applyManage',
        name: 'applyManage',
        component: applyManage
      }, {
        path: 'treeManage',
        name: 'treeManage',
        component: treeManage
      },{
        path:'tipsTplManage',
        name:'tipsTplManage',
        component:tipsTplManage
      },{
        path:'timeTplManage',
        name:'timeTplManage',
        component:timeTplManage
      },{
        path:'projectManage',
        name:'projectManage',
        component:projectManage
      },{
        path:'backendUserManage',
        name:'backendUserManage',
        component:backendUserManage
      },{
        path:'spotManage',
        name:'spotManage',
        component:spotManage
      },{
        path:'spotMonitorManage',
        name:'spotMonitorManage',
        component:spotMonitorManage
      },{
        path:'spotMonitorDetail',
        name:'spotMonitorDetail',
        component:spotMonitorDetail
      },{
        path:'spotMonitorDetail',
        name:'spotMonitorDetail',
        component:spotMonitorDetail
      },{
        path:'spotDetail',
        name:'spotDetail',
        component:spotDetail
      },{
        path:'spotCompare',
        name:'spotCompare',
        component:spotCompare
      },{
        path:'districtMapConfig',
        name:'districtMapConfig',
        component:districtMapConfig
      }]
    },
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('adminToken')
  if (to.path === '/login') {
    next()
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js